import { cn } from '@/lib/cn';

/**
 * The programme's vision statement, verbatim.
 *
 * Held as one exported const rather than inline in the markup for two reasons:
 * there is exactly one copy to change when it is re-ratified, and the wording
 * stays greppable. This sentence is quoted in board packs, so a silent drift
 * between the dashboard and the paper is the failure worth designing out.
 */
export const VISION_STATEMENT =
  'To be JCorp’s intelligence engine — an AI platform that senses, reasons, and ' +
  'acts across every business unit, delivering greater intelligence density, ' +
  'faster decisions, and sharper judgment in service of an AI-First Investment ' +
  'and Impact Institution.';

export interface HeroProps {
  className?: string;
}

/**
 * The vision band, between the navy app bar and the page content.
 *
 * Full-bleed surface so it reads as chrome rather than as a panel belonging to
 * whichever page happens to be mounted, with its text on the same
 * `max-w-board` column as `<main>` and the footer — so the statement's left
 * edge lines up with the KPI cards beneath it rather than floating free.
 *
 * Deliberately NOT a landmark. `Topbar` already renders the document's
 * `<header>`, and a second banner region would give assistive-technology users
 * one more thing to skip past before reaching the board. The statement is
 * standing context, not a navigational destination.
 */
export function Hero({ className }: HeroProps) {
  return (
    <div className={cn('border-b border-hairline bg-surface', className)}>
      <div className="mx-auto w-full max-w-board px-4 py-3.5">
        {/* No measure cap and no left rule: the statement runs the full board
            width so its edges align with the page content directly below. */}
        <p className="text-md font-semibold text-text-primary sm:text-lg">{VISION_STATEMENT}</p>
      </div>
    </div>
  );
}
